import { withStyles } from '@material-ui/core/styles';
import { MapOutlined } from '@material-ui/icons';
import supportHrefs from 'common/constants/supportHrefs';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { Divider } from 'evee-ui-common/components/base';
import { NotificationType } from 'evee-ui-common/enums';
import { history } from 'evee-ui-common/services';
import { getHomeUrl } from 'evee-ui-common/utils';
import useRegion from 'store/modules/app/hooks/useRegion';

import {
  Bolt,
  Calendar,
  Car,
  Envelope,
  File,
  Gift,
  Money,
  Notebooks,
  Settings,
  SignOut,
  User,
  Wallet,
} from '../../icons';
import Item from '../../utils/Item';
import NotificationsCount from '../../utils/NotificationsCount';
import styles from '../styles';

const HostItems = ({ customerId, classes, onSignOut, onClose }) => {
  const location = useLocation();
  const { region } = useRegion();

  return (
    <>
      <Item
        bold
        selected={location.pathname === '/account/trips'}
        label="Renting"
        icon={<Calendar />}
        onClick={() => {
          history.push('/account/trips');
          onClose();
        }}
      />

      <Item
        bold
        selected={location.pathname === '/account/cars'}
        label="Hosting"
        icon={<Money />}
        onClick={() => {
          history.push('/account/cars');
          onClose();
        }}
      />

      <Item
        selected={location.pathname === '/account/messages'}
        label="Messages"
        icon={<Envelope />}
        endDecoration={<NotificationsCount type={NotificationType.message} />}
        onClick={() => {
          history.push('/account/messages');
          onClose();
        }}
      />

      <Divider className={classes.divider} />

      <Item
        selected={location.pathname === '/account/edit'}
        label="Account"
        icon={<Settings />}
        onClick={() => {
          history.push('/account/edit');
          onClose();
        }}
      />

      <Item
        selected={location.pathname === `/account/${customerId}`}
        label="Profile"
        icon={<User />}
        onClick={() => {
          history.push(`/account/${customerId}`);
          onClose();
        }}
      />

      <Item
        label="Rewards"
        icon={<Bolt />}
        endDecoration={<NotificationsCount type={NotificationType.rewards} />}
        selected={location.pathname === `/account/rewards`}
        onClick={() => {
          history.push('/account/rewards');
          onClose();
        }}
      />

      <Item
        selected={location.pathname === '/listing/process'}
        label="List a car"
        icon={<Car />}
        onClick={() => {
          history.push('/listing/process');
          onClose();
        }}
      />

      <Divider className={classes.divider} />

      <Item
        label="All evee vehicles"
        selected={location.pathname.includes('/vehicles') || location.pathname.includes('/search')}
        icon={<MapOutlined />}
        onClick={() => {
          history.push('/vehicles');
          onClose();
        }}
      />

      <Item
        label="Insurance"
        icon={<File />}
        onClick={() => {
          window.location.href = `${getHomeUrl(region)}/insurance`;
        }}
      />

      <Item
        label="Novated leasing"
        icon={<Wallet />}
        onClick={() => {
          window.location.href = `${getHomeUrl(region)}/pages/novated-leasing`;
        }}
      />

      <Item
        label="Gift cards"
        icon={<Gift />}
        onClick={() => {
          window.location.href = `${getHomeUrl(region)}/giftcards`;
        }}
      />

      <Divider className={classes.divider} />

      <Item
        label="Get help"
        icon={<Notebooks />}
        onClick={() => {
          window.location.href = supportHrefs[region.id].helpCenter;
        }}
      />

      <Item label="Log out" icon={<SignOut />} onClick={onSignOut} />
    </>
  );
};

HostItems.propTypes = {
  customerId: PropTypes.string,
  classes: PropTypes.shape({
    divider: PropTypes.string.isRequired,
  }).isRequired,
  onSignOut: PropTypes.func,
  onClose: PropTypes.func,
};

HostItems.defaultProps = {
  customerId: '',
  onSignOut: () => {},
  onClose: () => {},
};

export default withStyles(styles)(HostItems);
